<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <form id="createCourse" @submit="createCourse" >
          <CCardHeader>
            <CCol col="6" style="font-size: 25px;">إضافة دورة جديدة</CCol>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col='4'>
                <div class='form-group'>
                    <label for='categories'>
                      الأقسام الرئيسية
                      <span class='star'>*</span>
                    </label>
                    <div>
                      <multiselect
                        class='required cat'
                        v-model='selectedCategory'
                        id='categories'
                        @select="onCategoriesChange($event)"
                        :options='categories'
                        :searchable='true'
                        selectedLabel=' العنصر المحدد'
                        deselectLabel='اضغط لإلغاء اختيار هذا العنصر'
                        selectLabel='اضغط لإختيار هذا العنصر'
                        :close-on-select='true'
                        placeholder=' اختر القسم المناسب '
                        label='name'
                        track-by='name'
                        required='required'
                      >
                        <span slot='noOptions'>اللائحة فارغة</span>
                        <span slot='noResult'>لا توجد نتيجة</span>
                      </multiselect>
                      <!-- <div v-if(errors.category_id) class="invalid-feedback">
                        {{errors.category_id}}
                      </div> -->
                    </div>
                  </div>
              </CCol>
              <CCol col='4'>
                <div class='form-group'>
                    <label for='subCategories'>
                      الأقسام الفرعيه
                      <span class='star'>*</span>
                    </label>
                    <div>
                      <multiselect
                        class='required sub'
                        v-model='selectedSubCategory'
                        id='subCategories'
                        :options='subCategories'
                        :searchable='true'
                        selectedLabel=' العنصر المحدد'
                        deselectLabel='اضغط لإلغاء اختيار هذا العنصر'
                        selectLabel='اضغط لإختيار هذا العنصر'
                        :close-on-select='true'
                        placeholder=' اختر القسم الفرعي المناسب '
                        label='name'
                        track-by='name'
                        required='required'
                      >
                        <span slot='noOptions'>اللائحة فارغة</span>
                        <span slot='noResult'>لا توجد نتيجة</span>
                      </multiselect>
                      <!-- <div v-if(errors.sub_category_id) class="invalid-feedback">
                        {{errors.sub_category_id}}
                      </div> -->
                    </div>
                  </div>
              </CCol>
            </CRow>
            <hr/>
            <CRow>
              <CCol col="6">
                <CInput label="English Name"
                  id="name"
                  v-model="course.name"
                  class="required"
                  placeholder=" أدخل إسم الدورة بالانجليزية"
                  :invalidFeedback="errors.name"
                  required
                />
              </CCol>
              <CCol col="6">
                <CInput label="الاسم"
                  id="name_ar"
                  v-model="course.name_ar"
                  class="required"
                  placeholder="أدخل إسم الدورة بالعربي"
                  :invalidFeedback="errors.name_ar"
                  required
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol col="6">
                <CInput label="تكلفة"
                  id="cost"
                  type="number"
                  v-model="course.cost"
                  min=0
                  class="required"
                  placeholder=" ادخل تكلفة الدورة"
                  :invalidFeedback="errors.cost"
                  required
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol col="6">
                <CInput label="عدد ساعات"
                  id="total_hours"
                  type="number"
                  v-model="course.total_hours"
                  class="required"
                  min=1
                  placeholder="أدخل عدد ساعات الدورة"
                  :invalidFeedback="errors.total_hours"
                  required
                />
              </CCol>
            </CRow>
            <CRow>
               <CCol col="6">
                <CInput label="عدد أيام الدورة المتاحة "
                  id="end_date"
                  type="number"
                  v-model="course.number_of_days"
                  class="required"
                  min=1
                  placeholder="عدد أيام الدورة المتاحة"
                  :invalidFeedback="errors.end_date"
                  required
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol col="6">
                <div class='form-group'>
                    <label for='instructors'>
                      المدرب
                      <span class='star'>*</span>
                    </label>
                    <div>
                      <multiselect
                        class='required instr'
                        v-model='selectedInstructor'
                        id='instructors'
                        :options='instructors'
                        :searchable='true'
                        selectedLabel=' العنصر المحدد'
                        deselectLabel='اضغط لإلغاء اختيار هذا العنصر'
                        selectLabel='اضغط لإختيار هذا العنصر'
                        :close-on-select='true'
                        placeholder=' اختر المدرب المناسب '
                        label='full_name'
                        track-by='full_name'
                        required='required'
                      >
                        <span slot='noOptions'>اللائحة فارغة</span>
                        <span slot='noResult'>لا توجد نتيجة</span>
                      </multiselect>
                      <!-- <div v-if(errors.instructor_id) class="invalid-feedback">
                        {{errors.instructor_id}}
                      </div> -->
                    </div>
                  </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="6">
                <div class='form-group'>
                  <label for='image' class="required">
                    أدخل صورة الدورة
                    <span class='star'>*</span>
                  </label>
                  <input type="file" class="form-control"
                    id="image"
                    required='required'
                    v-on:change="onFileChange"
                  >
                  <!-- <div v-if(errors.image) class="invalid-feedback">
                    {{errors.image}}
                  </div> -->
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="2">
                <label>محاور الدورة بالإنجليزية </label>
              </CCol>
              <CCol col="10">
                <client-only>
                  <VueEditor v-model='course.description' :invalidFeedback="errors.description" />
                </client-only>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="2">
                <label>محاور الدورة بالعربي </label>
              </CCol>
              <CCol col="10">
                <client-only>
                  <VueEditor v-model='course.description_ar' :invalidFeedback="errors.description_ar" />
                </client-only>
              </CCol>
            </CRow>
            <hr/>
            <hr/>
            <CRow>
              <CCol col="12">
                <h4>الوحدات</h4>
                <button class="btn btn-primary" type="button" @click="addSection">اضافة وحدة</button>
              </CCol>
            </CRow>
            <CRow>
              <table class="table mt-2">
                <thead>
                  <tr>
                  <th>إسم الوحدة بالعربي<span class='star'>*</span> </th>
                  <th>إسم الوحدة بالإنجليزية<span class='star'>*</span></th>
                  <th>حذف وحدة</th>
                  <th>إضافة درس</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(section, index) in sections"
                    :key="index"
                  >
                    <td>
                      <input
                        id="name"
                        v-model="section.name_ar"
                        class="required form-control"
                        placeholder="أدخل إسم الوحدة بالعربي"
                        required
                      />
                    </td>
                    <td>
                      <input
                        id="name"
                        v-model="section.name"
                        placeholder=" أدخل إسم الوحدة بالانجليزية"
                        class="required form-control"
                        required
                      />
                    </td>
                    <td>
                      <CButton
                        class="removeItem"
                        type="button"
                        size="xs"
                        color="danger"
                        @click="removeSection(index)"
                      >
                        حذف
                      </CButton>
                    </td>
                    <td>
                      <CButton
                        class="newItem"
                        type="button"
                        size="xs"
                        color="warning"
                        @click="addLesson(index)"
                      >
                        إضافة درس
                      </CButton>
                    </td>
                  </tr>
                </tbody>
              </table>
            </CRow>
            <CRow>
              <CCol col="12">
                <h3>الدروس</h3>
              </CCol>
            </CRow>
            <CRow>
              <CCol col="12">
                <table class="table">
                <thead>
                  <tr>
                  <th>إسم الوحدة </th>
                  <th>عنوان الدرس بالعربي<span class='star'>*</span></th>
                  <th>عنوان الدرس بالإنجليزية<span class='star'>*</span></th>
                  <th>الفيديو بصيغة (mp4)<span class='star'>*</span></th>
                  <th>حالة العرض</th>
                  <th>حذف درس</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(lesson, index) in lessons"
                    :key="index"
                  >
                    <td>{{lesson.section_name}}</td>
                    <td><input v-model="lesson.title_ar" class="form-control" required></td>
                    <td><input v-model="lesson.title" class="form-control" required></td>
                    <td>
                     <vue-dropzone ref="myUniqueID" @vdropzone-canceled='canceled'   :id="index" :use-custom-slot="true"   :options="dropzoneOptions" @vdropzone-file-added="getFileCount"  @vdropzone-success="Success" @vdropzone-sending="sendingEvent" @vdropzone-error="failed" @vdropzone-complete="test">
                         <!-- eslint-disable-next-line vue/valid-v-model -->
                        <span class='dropzone-custom-content' :data-value='index' >تحميل الفيديو</span>
                      </vue-dropzone>
                    </td>
                    <td>
                      <input type="checkbox" class="form-check-input" id="lesson-free" v-model="lesson.free" :checked="lesson.free" @change="changeLessonFree(lesson)">
                      <label class="form-check-label" for="lesson-free">مجاني</label>
                    </td>
                    <td>
                      <CButton
                        class="removeItem"
                        type="button"
                        size="xs"
                        color="danger"
                        @click="removeLesson(index)"
                      >
                        حذف
                      </CButton>
                    </td>
                  </tr>
                </tbody>
                </table>
              </CCol>
            </CRow>
              <CRow>
              <CCol col="12">
                <CTextarea
                  label='تقييم الدورة'
                  placeholder='أدخل رابط التقييم'
                  horizontal
                  rows='4'
                  v-model='course.review'
                  :invalidFeedback="errors.review"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton id='submit' @click=" validation() " type="submit" size="xs" color="primary" ><CIcon name="cil-check-circle"/> حفظ</CButton>
              &emsp;
            <CButton type="reset" size="xs" color="danger"><CIcon name="cil-ban"/> مسح </CButton>
          </CCardFooter>
          </form>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import $ from 'jquery'
import swal from 'sweetalert'
import { VueEditor } from 'vue2-editor'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
  name: 'CreateCourse',
  components: {
    VueEditor,
    vueDropzone: vue2Dropzone
  },
  data: function () {
    return {
      dropzoneOptions: {
        url: this.$hostUrl + 'medialibrary/upload',
        thumbnailWidth: 150,
        maxFilesize: 500,
        addRemoveLinks: true,
        autoProcessQueue: true,
        timeout: 200000,
        chunking: true,
        chunkSize: 2000000,
        headers: { Authorization: 'Bearer ' + localStorage.token },
        dictDefaultMessage: '<i class="fas fa-cloud-upload-alt"></i>تحميل الفيديو'

      },
      course: {},
      subCategories: [],
      selectedSubCategory: '',
      categories: [],
      selectedCategory: '',
      instructors: [],
      selectedInstructor: '',
      image: '',
      sections: [],
      lessons: [],
      errors: [],
      uploadPercentage: 0,
      videos: [],
      checkbox: '',
      allfiles: 0
    }
  },
  created () {
    const categories = []
    this.$http
      .get(`${this.$hostUrl}categories`)
      .then((response) => {
        $.each(response.data.data, function (key, value) {
          categories.push({ id: value.id, name: value.name_ar })
        })
        this.categories = categories
      })
    const subCategories = []
    this.$http
      .get(`${this.$hostUrl}sub-categories`)
      .then((response) => {
        $.each(response.data.data, function (key, value) {
          subCategories.push({ id: value.id, name: value.name_ar })
        })
        this.subCategories = subCategories
      })
    const instructors = []
    this.$http
      .get(`${this.$hostUrl}instructors`)
      .then((response) => {
        $.each(response.data.data, function (key, value) {
          instructors.push({ id: value.id, full_name: value.full_name_ar })
        })
        this.instructors = instructors
      })
  },
  methods: {
    // dropzone complete event
    test (response) {
      console.log(response, 'completed')
    },
    // dropzonevideo
    sendingEvent (file, xhr, formData) {
      xhr.ontimeout = () => {
      /* Execute on case of timeout only */
        swal('Server Timeout')
      }
      const $preview = $(file.previewElement)
      console.log($preview)
      const nearestele = $preview.parent().find('.dz-message').find('.dropzone-custom-content').data('value')
      formData.append('lesson_index', nearestele)
      formData.append('dzFilename', file.name)
      formData.append('dzTotalChunkCount', file.upload.totalChunkCount)
      formData.append('dzChunkIndex', file.upload.chunkIndex)
      formData.append('dzUuid', file.upload.uuid)
      if (typeof nearestele !== 'undefined') {
        formData.append('lesson_index', nearestele)
      }
    },
    getFileCount () {
      this.allfiles++
      console.log('videos count', this.allfiles)
    },
    canceled () {
      this.allfiles--
      console.log('videos count', this.allfiles)
    },
    onFileChange (e) {
      const _URL = window.URL || window.webkitURL
      this.image = e.target.files[0]
      let file = ''
      if ((file = e.target.files[0])) {
        const img = new Image()
        img.onerror = function () {
          swal('صيغة الملف غير مدعومة: ' + file.type)
          this.image = null
        }
        img.src = _URL.createObjectURL(file)
      }
    },
    onCategoriesChange ($event) {
      const subCategories = []
      this.$http
        .get(
            `${this.$hostUrl}categories/${$event.id}/sub-categories`
        )
        .then((response) => {
          $.each(response.data.data, function (key, value) {
            subCategories.push({ id: value.id, name: value.name_ar })
          })
          this.subCategories = subCategories
        })
    },

    addSection () {
      this.sections.push({
        id: (this.sections.length + 1),
        name: null,
        name_ar: null
      })
    },
    addLesson (index) {
      const section = this.sections[index]
      this.lessons.push({
        section_id: section.id,
        section_name: section.name_ar,
        id: null,
        title: null,
        title_ar: null,
        video: null,
        free: null,
        media_id: null
      })
    },
    Success (file, response) {
      const chunckresponse = JSON.parse(file.xhr.response)
      console.log(chunckresponse, 'sucess', response)
      if (chunckresponse.message) {
        swal(chunckresponse.message)
      }
      // Add media_id to the corresponding lesson
      if (chunckresponse && typeof chunckresponse.lesson_index !== 'undefined' && typeof chunckresponse.media_id !== 'undefined') {
        console.log(chunckresponse.media_id, 'media_id')
        this.lessons[chunckresponse.lesson_index].media_id = chunckresponse.media_id
      }
    },
    failed (file, message, xhr) {
      console.log('failed', xhr)
      swal('فشل التحميل')
      $('.dz-error-message span').text('خطأ بالشبكة')
    },
    removeSection (index) {
      const section = this.sections[index]
      let remove = 1
      $.each(this.lessons, function (key, value) {
        if (value.section_id === section.id) {
          remove = 0
        }
      })
      if (remove) {
        this.sections.splice(index, 1)
      } else {
        swal('لايمكن حذف وحده تحتوي على دروس')
      }
    },
    removeLesson (index) {
      this.lessons.splice(index, 1)
      this.videos.splice(index, 1)
    },
    changeLessonFree (event) {
      console.log(event)
      event.free = Number((event.free ? 1 : 0))
    },
    async createCourse (e) {
      e.preventDefault()
      // if (this.allfiles === this.videos.length && this.videos.length) {
      const formData = new FormData()
      if (this.selectedSubCategory) {
        formData.append('sub_category_id', this.selectedSubCategory.id)
      } else {
        this.errors.push('sub_category_id')
        this.errors.subcategory_id = 'subcategory id field is required'
        swal('يرجى تحديد قسم فرعي للدوره')
        $(' .sub .multiselect__tags').addClass('redborder')
        return 0
      }
      if (this.selectedInstructor) {
        formData.append('instructor_id', this.selectedInstructor.id)
      } else {
        this.errors.push('instructor_id')
        this.errors.instructor_id = 'instructor field is required'
        swal('يرجى تحديد مدرب للدوره')
        $('.instr .multiselect__tags').addClass('redborder')
        return 0
      }
      if (/^\d+$/.test(this.course.name)) {
        swal('اسم الدوره يجب ان يحتوي على حروف')
        $('#name').addClass('redborder')
        return 0
      }
      if (/^\d+$/.test(this.course.name_ar)) {
        swal('اسم الدوره عربي يجب ان يحتوي على حروف')
        $('#name_ar').addClass('redborder')
        return 0
      }
      formData.append('name', this.course.name)
      formData.append('name_ar', this.course.name_ar)
      if (this.course.cost > 0) {
        formData.append('cost', this.course.cost)
      } else {
        swal(' سعر الدوره  يجب ان يكون اكبر من صفر ')
        $('#cost').addClass('redborder')
        return 0
      }
      formData.append('total_hours', this.course.total_hours)
      formData.append('number_of_days', this.course.number_of_days)

      if (this.course.lesson_number) {
        formData.append('lesson_number', this.course.lesson_number)
      }
      if (this.image) {
        formData.append('image', this.image)
      }
      if (this.course.description_ar) {
        formData.append('description_ar', this.course.description_ar)
      }
      if (this.course.description) {
        formData.append('description', this.course.description)
      }
      if (this.sections.length) {
        formData.append('sections', JSON.stringify(this.sections))
      }
      if (this.lessons.length) {
        formData.append('lessons', JSON.stringify(this.lessons))
      }
      const videoCount = this.videos.length
      for (let index = 0; index < videoCount; index++) {
        formData.append('videos[]', this.videos[index])
      }
      if (this.course.review) {
        formData.append('review', this.course.review)
      }
      this.errors = await this.postRequest(formData, this.$hostUrl + 'courses', '/courses')
    },
    validation () {
      const Allinput = document.querySelectorAll('form input')
      Allinput.forEach((input) => {
        const select = input.hasAttribute('autocomplete')
        const attr = input.hasAttribute('data-video')
        // eslint-disable-next-line valid-typeof
        input.oninput = function () {
          input.classList.remove('redborder')
        }
        if (input.value === '' && input.type !== 'checkbox' && attr !== true && !select) {
          input.classList.add('redborder')
          swal(' لا يمكن ترك الحقل فارغا')
          return 0
        }
      })
    }
  }
}

</script>
<style >
.redborder{
  border-color:red !important
}

</style>
